import script from "./newTheme.vue?vue&type=script&setup=true&lang=ts"
export * from "./newTheme.vue?vue&type=script&setup=true&lang=ts"

import "./newTheme.vue?vue&type=style&index=0&id=48a225ca&lang=less&scoped=true"
import "./newTheme.vue?vue&type=style&index=1&id=48a225ca&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a225ca"]])

export default __exports__